export default "__VITE_ASSET__741a55df__"